/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsuarioInfoPersonalDto } from '../../models/usuario-info-personal-dto';

export interface PacientesControllerObtenerInformacionPersonal$Params {
}

export function pacientesControllerObtenerInformacionPersonal(http: HttpClient, rootUrl: string, params?: PacientesControllerObtenerInformacionPersonal$Params, context?: HttpContext): Observable<StrictHttpResponse<UsuarioInfoPersonalDto>> {
  const rb = new RequestBuilder(rootUrl, pacientesControllerObtenerInformacionPersonal.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsuarioInfoPersonalDto>;
    })
  );
}

pacientesControllerObtenerInformacionPersonal.PATH = '/api/pacientes/obtener-informacion-personal';
